import './styles/header.scss';
import './styles/top-bar.scss';
import { stickyHeaderMobile } from './stickyHeaderMobile';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
if (window.innerWidth < 1226) {
    stickyHeaderMobile();
}
(function () {
    if (window.innerWidth > 799)
        return;
    const searchComponent = document.querySelector('.sh__search');
    const header = document.querySelector('.site-header--new');
    if (isNullOrUndef(searchComponent) || isNullOrUndef(header))
        return;
    const updateHeightVariable = () => {
        document.documentElement.style.setProperty('--sticky-header-height', `${header.clientHeight}px`);
    };
    document.querySelector('.sh__icon--search')?.addEventListener('click', () => {
        searchComponent.classList.toggle('sh__search:opened');
        updateHeightVariable();
    });
}());
